export * from "./auth";
export * from "./files";
export * from "./helpers";
export * from "./types";

// Our Functions need javascript - so we need to link to our librarys so Typescript compiles them into JS!
//  Having this - allows us to reference it via the path (TSConfig Path) and causes it to be build - see Functions/dist folder
// So in Functions Index - we explicitly link into this function as a relative path!
export const CreateTypescriptLinkForCommonFunctions = (): void => {};

export function commonHello(): void {}
